
const MatrixContext = {
  MODEL: 'MODEL',
  SCENARIO: 'SCENARIO'
}

export default MatrixContext;